import { create, filter } from 'lodash';
import { searchSetting } from '../constants';
import myFetchWithId from '../helpers/myFetch';
import {errorActions} from './errorDisplay.actions';
import store from '.././store/'
import { func, string } from 'prop-types';
import { isEmpty, isArray, isObject } from 'lodash-es';


export function requestFetchApi(){
  return {
    type:searchSetting.REQUEST_FETCH_API
  }
}

export function receiveFetchApi(json,widgetId){
  // (2021 11 09) 這邊先無條件地加入錯誤訊息，只分有什麼情況的錯誤，有沒有空值給各 widget 自己判斷
  // 雖然檢查空值的 function 寫好了(emptyCheck) 但是因爲每個 widget 各自的變數太多了
  // 因為有些需要某 api 的特定幾個欄位的、有的全部都要，所以難以統合判斷到底什麼才是各 widget 的空值狀態

  if(json.response_status){
    return {
      type:searchSetting.RECEIVE_FETCH_API,
      fetchStatus:{[widgetId]:'查無資料，請檢查搜尋關鍵字是否有錯誤，或調整搜尋邏輯，若持續出現問題，請聯絡LOWI客服人員。'}
    }
  }
  
  if(json.message){
    return {
      type:searchSetting.RECEIVE_FETCH_API,
      fetchStatus:{[widgetId]:'資料抓取失敗，請檢查連線狀態，且隔一段時間後再次嘗試開啟，或重新整理網頁，若持續出現問題，請聯絡LOWI客服人員。'}
    }
  }
}


function emptyCheck(data){
  if(isObject(data)){
      return false
  }

  if(isEmpty(data)){
      return true
  }else{
      let set = isArray(data) ? data : Object.values(data)
      return !set.map(item=>emptyCheck(item)).includes(false)
  }
}

// (2021 10 01) 尚未完成
// 因為中間卡了很多 param ： 像是每個 receive 需要的 param 都不同 不可能為了每個都刻
// 也不能不能每個都改 因為這代表所有 widget 的 fetch function 裡每個的 param 都要被動到
// 這風險太大
// 但把這層邏輯包裝好可以解決很多事情
// 所以將這初步的流程先放著
// 以後如果有再看到 又能抽象的好的話就考慮實作
export function fetchLimit(isDashboard,fetchApi,receive,request=undefined){
  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    request ? dispatch(request()) : null
    return fetchApi().then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi())
      return dispatch(receive(json))
    })
    .catch(err => {console.log(err)})
  };
}
//------------------------------------------

export function fetchMyHistoryLog(){
  return dispatch => {
    dispatch(requestMyHistoryLog())
    return myFetchWithId('', true, true)('/v5/lowi/profile/v/release_notes', {})
    .then(json => {dispatch(receiveMyHistoryLog(json))})
    .catch(err => {dispatch(errorActions.update(err))})
  };
}
function requestMyHistoryLog() {
  return {
    type: searchSetting.REQUEST_MYHISTORYLOG,
    receivedAt: Date.now()
  }
}
function receiveMyHistoryLog(json) {
  const log = [...json.response_data]
  return {
    type: searchSetting.RECEIVE_MYHISTORYLOG,
    savedHistoryLog: json ? log : [],
    receivedAt: Date.now()
  };
}

export function fetchMyKeyword() {
  return dispatch => {
    dispatch(requestMyKeyword())
    return myFetchWithId('', true, true)('/v5/lowi/profile/ss/gets', {})
      .then(json => {
        let MyKeyword = json.response_data
        MyKeyword.forEach((item,index) =>{
          try{
            MyKeyword[index]['name']=decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(decodeURI(item.name))))))))))
          }catch(err){
            MyKeyword[index]['name'] =item.name
            console.log('error in decode keywords '+err)
          }
        })
        dispatch(receiveMyKeyword(MyKeyword))
      })
      .catch(err => dispatch(errorActions.update(err)))
  }
}
function requestMyKeyword() {
  return {
    type: searchSetting.REQUEST_KEYWORD,
    receivedAt: Date.now()
  }
}
function receiveMyKeyword(json) {
  return {
    type: searchSetting.RECEIVE_KEYWORD,
    savedKeywords: json ? json : [],
    receivedAt: Date.now()
  };
}
export function storeKeywordColor(color){
  console.log(color)
  return {
    type: searchSetting.RECEIVE_KEYWORD_COLOR,
    keywordColor:color,
  }
}

export function inputKeyword(keyword, abbreviation,autophrase, displayKeyword) {
  // console.log('key: '+keyword+', abb :' +abbreviation+', auto: '+autophrase+', display: '+ displayKeyword,)
  return {
    type: searchSetting.A_KEYWORD,
    serachKeyword: filterKeyword(keyword),
    abbKeyword: filterKeyword(abbreviation),
    autophrase:autophrase,
    keywordFromGuide: filterKeyword(displayKeyword),
    receivedAt: Date.now(),
  }
}

function filterKeyword(keyword){
  // if(typeof(keyword) === 'string' ){
  //     // const regx = /\*/gi;
  //     const words = keyword.split(' ')
  //     let sentence =''
  //     words.forEach(word=>{
  //         const index = word.indexOf("*")
  //         if(index !== -1 && word !=='*') sentence = sentence+' '+word
  //         if(index === -1) sentence = sentence+' '+word
  //     })
  //     return sentence.trim()
  // }
  return keyword
}

export function saveKeyword(keyword) {
  return {
    type: searchSetting.S_KEYWORD,
    savedKeyword: keyword,
    receivedAt: Date.now()
  }
}


export function removeType(obj){
  let selectedMediaType = [...store.getState().search.selectedMediaType]
  let glb_type =[...store.getState().search.glb_type]
  if(obj==='新聞'){
    selectedMediaType[0]=false
    glb_type =glb_type.filter(item => item !== 'NEWS')
  }
  else if(obj ==='論壇'){
    selectedMediaType[1]=false
    glb_type =glb_type.filter(item => item !== 'BBS')
  }
  else if(obj ==='社群'){
    selectedMediaType[2]=false
    glb_type =glb_type.filter(item => item !== 'SM')
  }
  else{
    selectedMediaType[3]=false
    glb_type =glb_type.filter(item => item !== 'BLOG')
  }

  return {
    type:searchSetting.REMOVE_TYPE,
    selectedMediaType:selectedMediaType,
    glb_type:glb_type,
  }


  // console.log('type')
  // console.log(selectedMediaType)

}

export function applyType(fillterType,typeTag,typelist, checklist, selecttype) {
  if(fillterType){
    return {
      type: searchSetting.A_TYPE,
      typeTag:typeTag,
      typeNotTag:[],
      mediaType: typelist,
      checkedList: checklist,
      selectedMediaType: selecttype,
      // receivedAt: Date.now()
    };
  }
  else{
    return {
      type: searchSetting.A_TYPE,
      typeTag:[],
      typeNotTag:typeTag,
      mediaType: typelist,
      checkedList: checklist,
      selectedMediaType: selecttype,
      // receivedAt: Date.now()
    };
  }

}

export function applyMedia(filterList) {

  if (filterList==='CLEAN') {
    return {
      type: searchSetting.A_MEDIA_CLEAN,
    };
  } else {
    return {
      type: searchSetting.A_MEDIA,
      source: filterList,
      checkedFromRedux: filterList,
      receivedAt: Date.now()
    };
  }
}

export function applyNotMedia(filterList) {
  if (filterList==='CLEAN'){
    return {
      type: searchSetting.A_NOT_MEDIA_CLEAN,
    };
  } else {
    return {
      type: searchSetting.A_NOT_MEDIA,
      sourceNot: filterList,
      checkedFromRedux: filterList,
      receivedAt: Date.now()
    };
  }
}

export function applyChKey(type,ch,keys) {
  return {
    type: searchSetting.A_CHKEY,
    filter:type,

    chKeys: type=== 1 ? keys : [],
    chNotKeys: type=== 1 ? [] : keys,

    ch:type=== 1 ? ch :[],
    chNot:type=== 1 ? [] : ch,

    receivedAt: Date.now()
  }
}

//儲存頻道 
export function applyMediafromArticle(block, type, media) {
  let ch=[],
      chNot=[],
      source=[],
      sourceNot=[],
      chKeys=[]

  if(type=== 'source'){
    if(block){
      sourceNot = [media.GLB_SOURCE]
    }else{
      // 僅看
      source = [media.GLB_SOURCE]
    }
  }else{
    if(block){
      chNot = [{key:media.GLB_CHANNEL_KEY,name:media.GLB_CHANNEL_LV1,source:media.GLB_SOURCE,type:media.GLB_TYPE}]
      chKeys = [media.GLB_CHANNEL_KEY]
    }else{
      // 僅看
      ch = [{key:media.GLB_CHANNEL_KEY,name:media.GLB_CHANNEL_LV1,source:media.GLB_SOURCE,type:media.GLB_TYPE}]
      chKeys = [media.GLB_CHANNEL_KEY]
    }
  }

  return{
    type: searchSetting.A_MEDIA_FROM_ARTICLE,
    ch:ch,
    chNot:chNot,
    source:source,
    sourceNot:sourceNot,
    chKeys:chKeys,
    receivedAt: Date.now()
  }
}

export function filterAction(type) {
  return {
    type: searchSetting.FILTER_ACTION,
    filterTypeFromRedux: type
  }
}

export function changeSMethodRedux(value) {
  return {
    type: searchSetting.SEARCH_METHOD,
    exact: value,
    receivedAt: Date.now()
  };
}

export function cleanAllSearchCondition(){
  return{
    type:searchSetting.CLEAN_ALL,
    receivedAt: Date.now()
  };
}

export function removeGroupFilter(type,obj,parent){
  const newObjs = parent.filter(item => item.id !== obj.id);
  switch(type){
    case "AUTHOR" :
      return {type: searchSetting.REMOVE_GROUP_FILTER, authorGroup: newObjs, receivedAt: Date.now()}
    case "AUTHOR_NOT" :
      return {type: searchSetting.REMOVE_GROUP_FILTER, authorGroupNot: newObjs, receivedAt: Date.now()}
  }
}

//filter
export function removeFilter(type, obj, parent) {

  if(type == 'CH' || 'CH_NOT'){
    const newObjs = parent.filter(item => item.key !== obj.key);
    console.log('from channel'+newObjs)

    switch(type){
      case 'CH':
        return {type: searchSetting.REMOVE_FILTER, ch: newObjs,chChecked:newObjs, receivedAt: Date.now()};
      case 'CH_NOT':
        return {type: searchSetting.REMOVE_FILTER, chNot: newObjs,chChecked:newObjs, receivedAt: Date.now()};
     }
  }

  const checkedList = store.getState().search.checkedList

  let theIndex =''
  let newCheckedList =[]
  let temp =[]

  temp.push(...checkedList)

  newCheckedList.push(...temp)
  
  newCheckedList = newCheckedList.map((item, index) => {
    if(item.checked.find((item)=> item === obj)){
      theIndex = index
    }

    if (index === theIndex) {
        item.checked = item.checked.filter(item=> item != obj)
        return { type: item.type, checked:item.checked};
    } else {
      return item;
    }
  });


//------------------------------------------------------------//
  const newObjs = parent.filter(item => item !==obj);

  console.log('from other '+newObjs)

  switch (type) {
    case 'AUTHOR':
      return {type: searchSetting.REMOVE_FILTER, author: newObjs, receivedAt: Date.now()};
    case 'AUTHOR_NOT':
      return {type: searchSetting.REMOVE_FILTER, authorNot: newObjs, receivedAt: Date.now()};
    case 'DOC':
      return {type: searchSetting.REMOVE_FILTER, doc: newObjs, receivedAt: Date.now()};
    case 'DOC_NOT':
      return {type: searchSetting.REMOVE_FILTER, docNot: newObjs, receivedAt: Date.now()};
    // ---------- 因為 channel 是用 key 去搜尋的 所以需要同時改變 name 和 key(ch chkey) 2020 10 12
    case 'CHKEYS':
      return {type: searchSetting.REMOVE_FILTER, chKeys: newObjs,channelFromRedux:newObjs, receivedAt: Date.now()};
    case 'CHNOTKEYS':
      return {type: searchSetting.REMOVE_FILTER, chNotkey: newObjs,channelFromRedux:newObjs, receivedAt: Date.now()};
    // -----------------------------------//
    case 'TYPETAG':
      return {type: searchSetting.REMOVE_FILTER, typeTag: newObjs, receivedAt: Date.now()}
    case 'TYPE_NOT_TAG':
      return {type: searchSetting.REMOVE_FILTER, typeNotTag: newObjs, receivedAt: Date.now()}
    // case 'TYPE':
    //   return {type: searchSetting.REMOVE_FILTER, type: newObjs, receivedAt: Date.now()}
    // case 'TYPE_NOT':
    //   return {type: searchSetting.REMOVE_FILTER, typeNot: newObjs, receivedAt: Date.now()}
    case 'SOURCE':
      return {type: searchSetting.REMOVE_FILTER, source: newObjs,checked:newObjs,receivedAt: Date.now()};
    case 'SOURCE_NOT':
      return {type: searchSetting.REMOVE_FILTER, sourceNot: newObjs,checked:newObjs,receivedAt: Date.now()};

    default: {type: searchSetting.REMOVE_FILTER};
  }
}

// Author
export function fetchMyAuthors() {
  return dispatch => {
    dispatch(requestMyAuthors())
    return myFetchWithId('', true)('/v5/lowi/profile/sa/gets', {})
      .then(json => {dispatch(receiveMyAuthors(json))})
      .catch(err => dispatch(errorActions.update(err)))
  }
}

function requestMyAuthors() {
  return {
    type: searchSetting.REQUEST_MYAUTHOR,
    receivedAt: Date.now()
  }
}
function receiveMyAuthors(json) {
  return {
    type: searchSetting.RECEIVE_MYAUTHOR,
    savedAuthors: json.response_data ? json.response_data : [],
    selectedAuthor: json.response_data ? new Array(json.response_data.length).fill(false) : [],
    receivedAt: Date.now()
  };
}

export function applyAuthor(block, author) {
  if (block===true) {
    return {
      type: searchSetting.APPLY_NOT_AUTHOR,
      authorNot: encodeURIComponent(author),
      // receivedAt: Date.now()
    };
  }else {
    return {
      type: searchSetting.APPLY_AUTHOR,
      author: encodeURIComponent(author),
      // receivedAt: Date.now()
    };
  }
}

export function applyAuthorGroup(block, authors){
  if (block===true) {
    return {
      type: searchSetting.APPLY_NOT_AG,
      authorGroupNot: authors,
      // receivedAt: Date.now()
    };
  }else {
    return {
      type: searchSetting.APPLY_AG,
      authorGroup: authors,
      // receivedAt: Date.now()
    };
  }
}

export function selecteAuthor(tIndex, selectedArray) {
  const newArray = selectedArray.map((ele, index) => {
    if (tIndex===index) {
      return true;
    } else {
      return false;
    }
  })
  return {
    type: searchSetting.SELECT_AUTHOR,
    selectedAuthor: newArray
  };
}
// Media list
export function fetchMyMediaList(keepId) {
  return dispatch => {
    dispatch(requestMyMediaList())
    return myFetchWithId('', true)('/v5/lowi/profile/sc/get_user_sclist', {})
      .then(json => {dispatch(receiveMyMediaList(json, keepId))})
      .catch(err => dispatch(errorActions.update(err)))
  }
}
function requestMyMediaList() {
  return {
    type: searchSetting.REQUEST_MYMEDIA,
    receivedAt: Date.now()
  }
}
function receiveMyMediaList(json, keepId) {
  return {
    type: searchSetting.RECEIVE_MYMEDIA,
    savedMediaList: json.response_data ? json.response_data : [],
    keepMediaListId: keepId,
    receivedAt: Date.now()
  };
}
export function selecteMyMediaList(id, lists) {
  const selectedMediaId = lists.filter(obj => id===obj.id)[0].id;
  return {
    type: searchSetting.SELECT_MYMEDIA,
    selectedMediaId: selectedMediaId
  };
}
// Article
export function fetchMyArticles() {
  return dispatch => {
    dispatch(requestMyArticles())
    return myFetchWithId('', true)('/v5/lowi/profile/doc/get_user_doclist', {})
      .then(json => {dispatch(receiveMyArticles(json))})
      .catch(err => dispatch(errorActions.update(err)))
  }
}
function requestMyArticles() {
  return {
    type: searchSetting.REQUEST_MYDOC,
    receivedAt: Date.now()
  }
}
function receiveMyArticles(json) {
  return {
    type: searchSetting.RECEIVE_MYDOC,
    savedDocs: json.response_data ? json.response_data : [],
    selectedDocs: json.response_data ? new Array(json.response_data.length).fill(false) : [],
    receivedAt: Date.now()
  };
}

export function applyArticle(block, article) {
  if (block===true) {
    return {
      type: searchSetting.APPLY_NOT_DOC,
      docNot: article,
      // receivedAt: Date.now()
    };
  }else {
    return {
      type: searchSetting.APPLY_DOC,
      doc: article,
      // receivedAt: Date.now()
    };
  }
}

export function applyArticleGroup(block, articles) {
  console.log(articles)
  if (block) {
    return {
      type: searchSetting.APPLY_NOT_DG,
      docGroupNot: articles
    }
  } else {
    return {
      type: searchSetting.APPLY_DG,
      docGroup: articles
    }
  }
}

export function selecteArticle(tIndex, selectedArray) {
  const newArray = selectedArray.map((ele, index) => {
    if (tIndex===index) {
      return true;
    } else {
      return false;
    }
  })
  return {
    type: searchSetting.SELECT_DOC,
    selectedDocs: newArray
  };
}

export function fetchMyWidgets() {
  return dispatch => {
    dispatch(requestMyWidgets())
    return myFetchWithId('', true)('/v5/lowi/profile/get_allow_template', {})
      .then(json => {dispatch(receiveMyWidgets(json))})
      .catch(err => dispatch(errorActions.update(err)))
  }
}
function requestMyWidgets() {
  return {
    type: searchSetting.REQUEST_MYWIDGETS,
    receivedAt: Date.now()
  }
}
function receiveMyWidgets(json) {
  return {
    type: searchSetting.RECEIVE_MYWIDGETS,
    availableWidgets: json.response_data,
    receivedAt: Date.now()
  };
}

export function fecthMyAlerts() {
  return dispatch => {
    dispatch(requestMyAlerts())
    return myFetchWithId('', true, true)('/v5/lowi/profile/alarm/get_alarm', {})
      .then(json => {dispatch(receiveMyAlerts(json))})
      .catch(err => dispatch(errorActions.update(err)))
  }
}
function requestMyAlerts() {
  return {
    type: searchSetting.REQUEST_MYALERTS,
    receivedAt: Date.now()
  }
}
function receiveMyAlerts(json) {
  const selectedAlertId = json.response_data.length > 0 ? json.response_data[0].id : null
  return {
    type: searchSetting.RECEIVE_MYALERTS,
    savedAlerts: json.response_data,
    selectedAlertId: selectedAlertId,
    receivedAt: Date.now()
  };
}

export function selectAlert(id){
  return {
    type: searchSetting.CHANGE_SELECT_ALERT_ID,
    selectedAlertId: id
  };
}

export function fetchMyDiffusion() {
  return dispatch => {
    dispatch(requestMyDiffusion())
    return myFetchWithId('', true, true)('/v5/lowi/profile/get_diffusion', {})
    .then(json => {dispatch(receiveMyDiffusion(json))})
    .catch(err => {dispatch(errorActions.update(err))})
  };
}
function requestMyDiffusion() {
  return {
    type: searchSetting.REQUEST_MYDIFFS,
    receivedAt: Date.now()
  }
}
function receiveMyDiffusion(json) {
  if (json.response_status==='SUCCESS' && json.diffusion) {
    return {
      type: searchSetting.RECEIVE_MYDIFFS,
      diffusionStting: json.diffusion,
      receivedAt: Date.now()
    };
  } else {
    return {
      type: searchSetting.RECEIVE_MYDIFFS,
      diffusionStting: {
        "b_weight": 1,
        "l_weight": 1,
        "r_weight": 1,
        "s_weight": 1
      },
      receivedAt: Date.now()
    };
  }
  // tofo
  // else {
  //   return {
  //     type: searchSetting.RECEIVE_MYDIFFS,
  //     diffusionStting: json.diffusion,
  //     receivedAt: Date.now()
  //   };
  // }
}

export function setMyDiffusion(diffusion){
  return dispatch => {
    return myFetchWithId('', true, true)('/v5/lowi/profile/diffusion',diffusion)
    .then(json => {dispatch(receiveMyDiffusionSet(diffusion))})
    .catch(err => {console.log(err)})
  };
}

function receiveMyDiffusionSet(diffusion){
  let diffusionStting ={
    b_weight : typeof(diffusion.bweight) === string ? parseInt(diffusion.bweight) : diffusion.bweight,
    r_weight : typeof(diffusion.r_weight) === string ? parseInt(diffusion.rweight) : diffusion.rweight,
    l_weight : typeof(diffusion.l_weight) === string ? parseInt(diffusion.l_weight) : diffusion.lweight,
    s_weight : typeof(diffusion.s_weight) === string ? parseInt(diffusion.s_weight) : diffusion.sweight,
  }
  
  return {
    type: searchSetting.RECEIVE_MY_DIFFUSION_SET,
    diffusionStting: diffusionStting,
    receivedAt: Date.now()
  };
}


// WEBPACK FOOTER //
// ./src/actions/search.actions.js